import React, { forwardRef, useState } from "react";

import Scrollbar from "react-scrollbars-custom";

const showScrollbarStyle = {
  style: {
    visibility: "visible", opacity: 1, transition: "opacity 0.1s linear",
  },
};

const hideScrollbarStyle = {
  style: {
    visibility: "hidden", opacity: 0, transition: "visibility 0s 0.3s, opacity 0.3s linear",
  },
};

/**
 * App-wide scrollbar (react-scrollbars-custom). Thumb colors: --color-scrollbar-thumb* in tokens.css.
 * @param {boolean|'x'|'y'} autoHide - true/'y' = vertical track fades until hover; 'x' = horizontal
 */
const StyledScrollbar = forwardRef(({
  autoHide = false,
  className = "",
  trackYProps,
  trackXProps,
  onMouseEnter,
  onMouseLeave,
  ...rest
}, ref) => {
  const hideY = autoHide === true || autoHide === "y";
  const hideX = autoHide === "x";

  const [hovered, setHovered] = useState(false);
  const fadeProps = hovered ? showScrollbarStyle : hideScrollbarStyle;

  const toggleHover = (next, handler) => (event) => {
    if (hideY || hideX) setHovered(next);
    if (handler) handler(event);
  };

  return (
    <Scrollbar
      ref={ref}
      className={["StyledScrollbar", className].filter(Boolean).join(" ")}
      trackYProps={hideY ? { ...fadeProps, ...trackYProps } : trackYProps}
      trackXProps={hideX ? { ...fadeProps, ...trackXProps } : trackXProps}
      onMouseEnter={toggleHover(true, onMouseEnter)}
      onMouseLeave={toggleHover(false, onMouseLeave)}
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    />
  );
});

StyledScrollbar.displayName = "StyledScrollbar";

export default StyledScrollbar;
